module.exports = __webpack_public_path__ + "img/Pattern.fb8b6fe6.svg";